import { ref, onValue, getDatabase } from "firebase/database";
// import { database } from "../../services/firebase/initFirebase";
import { QueryKeys } from "./query-client";
import { useQuery } from "react-query";
import { EntryData } from "../../constants/model/models";
import { useRouter } from "next/router";
import * as firebase from "firebase/app";
import { firebaseConfig } from "../../constants/env";

export interface SpecialtyData extends EntryData {
  name: string;
  category: string;
}

export function useSpecialtyList() {
  const router = useRouter();
  if (!firebase.getApps().length) {
    firebase.initializeApp(firebaseConfig);
  } else {
    firebase.getApp(); // if already initialized, use that one
  }
  const database = getDatabase(firebase.getApp());

  const publishedSpecialtiesRef = ref(
    database,
    `published/specialties/${router.locale}`
  );
  const {
    data: specialties,
    isFetching: specialtiesAreLoading,
    isError: specialtiesError,
  } = useQuery([QueryKeys.SPECIALTIES, router.locale], () => getEntries(), {
    keepPreviousData: true,
    retry: 2,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
  });

  // wrap blog entries subscription into a promise to be used with react-query
  function getEntries(): Promise<Record<string, SpecialtyData> | null> {
    return new Promise((resolve, reject) => {
      onValue(
        publishedSpecialtiesRef,
        async (snapshot) => {
          const publishedEntries: Record<string, SpecialtyData> =
            snapshot.val();
          resolve(publishedEntries);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  return { specialties, specialtiesAreLoading, specialtiesError };
}
